import { getUserStorage } from "util/local_storage";
import decodeAccessToken from "util/decode_access_token";

/**
 * Check if the accessToken has expired
 * @returns true if token is expired, false if still valid
 */
const isTokenExpired = (): boolean => {
  const user = getUserStorage();
  if (!user?.accessToken) {
    return true;
  }

  try {
    const decoded: any = decodeAccessToken(user.accessToken);
    if (!decoded || !decoded.exp) {
      return true;
    }

    // exp in JWT is Unix timestamp (seconds)
    // Check if token has expired
    const currentTime = Math.floor(Date.now() / 1000);
    return decoded.exp <= currentTime;
  } catch (error) {
    return true;
  }
};

export default isTokenExpired;
